// extracted by mini-css-extract-plugin
module.exports = {"root":"button_root__2ycHM"};